<template>
  <a-modal
    :title="form.supplier_id ? '修改供应商信息' : '新增供应商信息'"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    destroyOnClose
    :maskClosable="false"
    width="800px"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="供应商名称" prop="supplier_name">
            <a-input
              v-model="form.supplier_name"
              placeholder="请输入供应商名称"
            />
          </a-form-model-item>
          <a-form-model-item label="公司名称" prop="company_name">
            <a-input v-model="form.company_name" placeholder="请输入公司名称" />
          </a-form-model-item>
          <a-form-model-item label="联系人" prop="contacts">
            <a-input v-model="form.contacts" placeholder="请输入联系人" />
          </a-form-model-item>
          <a-form-model-item label="联系方式" prop="phone">
            <a-input v-model="form.phone" placeholder="请输入" />
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remark">
            <a-input v-model="form.remark" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="账户名称" prop="account_name">
            <a-input v-model="form.account_name" placeholder="请输入" />
          </a-form-model-item>
          <a-form-model-item label="账户号码" prop="account_number">
            <a-input v-model="form.account_number" placeholder="请输入" />
          </a-form-model-item>
          <a-form-model-item label="开户银行" prop="bank_name">
            <a-input v-model="form.bank_name" placeholder="请输入" />
          </a-form-model-item>
          <a-form-model-item label="开户支行" prop="bank_branch">
            <a-input v-model="form.bank_branch" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        supplier_id: "",
        supplier_name: "",
        company_name: "",
        contacts: "",
        phone: "",
        account_name: "",
        account_number: "",
        bank_name: "",
        bank_branch: "",
        remark: "",
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        supplier_name: [
          {
            required: true,
            message: "请输入供应商名称",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.supplier_id = id;
      if (id) {
        this.$http({
          url: "/admin/supplier/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = { ...res.data };
        });
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.supplier_id
              ? "/admin/supplier/update"
              : "/admin/supplier/create",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success(this.form.supplier_id ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
</style>